import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';

import { meRoleState } from '../atom';
import type { Role } from '../types';

export const useMeRolesResponse = () => {
  const setMeRoles = useAtomCallback(
    useCallback((_get, set, data: Role[]) => {
      data.forEach((d) => {
        set(meRoleState(d.id), d);
      });
    }, [])
  );

  return {
    setMeRoles,
  };
};
